// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/metar-cloud-abbreviations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/metar-cloud-abbreviations/metar-cloud-abbreviations.js';
import g1 from '../lessons/meteorology/metar-cloud-abbreviations/sky-cover-amounts.js';

mount([g0, g1]);
